/**
 * Attempts to find the most useful human-readable pretty name
 * for a React component class.
 */
export default function getDisplayName(ComponentClass) {
    return ComponentClass.displayName || ComponentClass.name || 'Component';
}
